// Auto-generated normalizer for table: CAR_BOOKING.SolicitanteUnidadesOrganizacionales
export function solicitanteUnidadesOrganizacionalesNormalize(row) {
  return {
    idSolicitanteUnidadesOrganizacionales: row.idSolicitanteUnidadesOrganizacionales ?? row.IdSolicitanteUnidadesOrganizacionales ?? row['idSolicitanteUnidadesOrganizacionales'] ?? 0,
    idSolicitante: row.idSolicitante ?? row.IdSolicitante ?? row['idSolicitante'] ?? 0,
    idUnidadOrganizacional: row.idUnidadOrganizacional ?? row.IdUnidadOrganizacional ?? row['idUnidadOrganizacional'] ?? 0,
    activo: row.activo ?? row.Activo ?? row['activo'] ?? false,
  };
}